import { FormText } from './FormText'

export function FormTextPdfEditor (props) {
  return <FormText {...props} />
}
